// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"65":"b3eabaa3","615":"b873bd74","886":"2cd46f9c"}[chunkId] + ".chunk.css";
};